import { initMoving } from "@/effects";
import type { TQuestion, TSetState } from "@/types";

export const renderQuiz = (content: HTMLDivElement, setState: TSetState) => {
  const questions: Array<TQuestion> = [
    {
      question: "Moje oblíbené jídlo? 😏",
      answers: ["Chlebík 🍞", "Autobusek 🚌", "Carbonara 😋"],
      correctIndex: 2
    },
    {
      question: "Aktuální počet neumytého nádobí nacházející se v mé kuchyni 🤭",
      answers: ["0 😮", "67 🥴", "69 😏"],
      correctIndex: 0
    },
    {
      question: "Koho nejvíc miluju? 😘",
      answers: [
        "Bojová Helikoptéra F-35 s přídavnými motory 😩",
        "Tebe ❤️",
        "Minecraft 😻"
      ],
      correctIndex: 1
    }
  ];

  let currentQuestion = 0;
  let score = 0;

  const renderStart = () => {
    content.innerHTML = `  
      <div class="text-center flex flex-col items-center">
        <h1 class="text-3xl text-shadow-md text-fuchsia-600 relative bottom-28 sm:bottom-5">Nejprve kvíz o mně 😏</h1>
        <div id="startWrap" class="fixed flex transition-all duration-500 p-8">     
          <button id="beginQuiz" class="bg-indigo-500 text-white shadow-lg shadow-indigo-500/50 px-6 py-3 rounded-xl">
            Začít kvíz
          </button>
        </div>  
      </div>  
    `;

    currentQuestion = 0;
    score = 0;

    initMoving(document.querySelector("#startWrap")!, [
      { limit: 5, text: "Musíš si mě chytit 😏" },
      { limit: 10, text: "Nejde to co? 🤭" },
      { limit: Infinity, text: "Ty to zvládneš ❤️" }
    ]);
    document.querySelector("#beginQuiz")!.addEventListener("click", renderQuestion);
  };

  const renderQuestion = () => {
    console.log(currentQuestion);
    const question = questions[currentQuestion];

    content.innerHTML = `
      <div class="text-center flex flex-col items-center gap-6">  
        <h2 class="text-2xl text-shadow-md text-pink-600">${question.question}</h2>
        <div id="answers" class="flex flex-col gap-4 items-center"></div>
      </div>
    `;

    const answersDiv = document.querySelector("#answers")!;

    question.answers.forEach((answer, index) => {
      const btn = document.createElement("button");
      btn.textContent = answer;
      btn.className = "bg-white px-6 py-3 rounded-xl shadow-lg";

      btn.addEventListener("click", () => {
        if (index === question.correctIndex) score++;
        currentQuestion++;

        if (currentQuestion >= questions.length) {
          if (score !== 3) {
            renderFailed();

            return;
          }
          renderSuccess();
        } else {
          renderQuestion();
        }
      });

      answersDiv.appendChild(btn);
    });
  };

  const renderSuccess = () => {
    content.innerHTML = `  
      <div class="text-center space-y-6">
        <h2 class="text-2xl text-shadow-md text-fuchsia-600">Šikulka, máš to hotovo 😄</h2>
        <p>Správné odpovědi: ${score} / ${questions.length} 🥳</p>
        <button id="nextSectionSuccess" class="bg-indigo-500 text-white shadow-lg shadow-indigo-500/50 w-max px-6 py-3 rounded-xl">
          Další sekce 😏
        </button>  
      </div>
    `;

    document
      .querySelector("#nextSectionSuccess")!
      .addEventListener("click", () => setState("game"));
  };

  const renderFailed = () => {
    content.innerHTML = `  
      <div class="text-center space-y-6">
        <h2 class="text-2xl text-shadow-md text-fuchsia-600">Zkus to laskavě znova jo? 🙄</h2>
        <p>Správné odpovědi: ${score} / ${questions.length} 😄</p>
        <button id="nextSectionFailed" class="bg-indigo-500 text-white shadow-lg shadow-indigo-500/50 w-max px-6 py-3 rounded-xl">
          Spustit testík znova 😋
        </button>   
      </div>    
    `;

    document
      .querySelector("#nextSectionFailed")!
      .addEventListener("click", () => renderStart());
  };

  renderStart();
};
